import React, { useState } from 'react';
import posthog from 'posthog-js';
import { Select, SelectOption } from '../../atoms/Select';
import SizeGuideModal from '../../../components/Modal/SizeGuideModal';
import { Label } from '../../typography';
import { getProductIDFromShopifyGID, getProductType, getStage } from '../../../utils/product';
import { isUserLoggedIn } from '../../../utils/analytics';
import { Link } from '../../atoms/Link/link';

export interface SizeSelectorProps {
  sizes: SelectOption[];
  selectedSize?: SelectOption;
  onSizeChange: (size: SelectOption) => void;
  error?: boolean;
  disabled?: boolean;
  product?: Shopify.Product;
  showSizeGuide?: boolean;
  sizeGuideText?: string;
  className?: string;
  user?: User;
}

export const SizeSelector = ({
  sizes,
  selectedSize,
  onSizeChange,
  error = false,
  disabled = false,
  product,
  showSizeGuide = true,
  sizeGuideText = "What's my size?",
  className,
  user,
}: SizeSelectorProps) => {
  const [isSizeGuideOpen, setIsSizeGuideOpen] = useState(false);

  const handleSizeGuideClick = () => {
    setIsSizeGuideOpen(true);

    // Track size guide opened event
    if (product) {
      posthog.capture('size_guide_opened', {
        product_id: getProductIDFromShopifyGID(product.id ?? ''),
        product_title: product.title,
        product_type: product.productType,
        is_logged_in: isUserLoggedIn(user),
        productStage: getStage(product.tags ?? []),
      });
    }
  };

  return (
    <div className={className}>
      {/* Label and Size Guide Link Row */}
      <div className="mb-2 flex items-center justify-between">
        <Label size="small">Size</Label>
        {showSizeGuide && (
          /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
          <Link onClick={handleSizeGuideClick}>
            <Label size="small" color="primary-blurple">
              {sizeGuideText}
            </Label>
          </Link>
        )}
      </div>
      <Select
        options={sizes}
        selectedOption={selectedSize}
        onChange={onSizeChange}
        label={undefined}
        placeholder={disabled ? 'Sold Out' : 'Choose your size'}
        error={error}
        disabled={disabled}
      />
      {product && (
        <SizeGuideModal
          productType={getProductType(product.productType || '')}
          isOpen={isSizeGuideOpen}
          closeModal={() => setIsSizeGuideOpen(false)}
          product={product}
        />
      )}
    </div>
  );
};
